import { Middleware } from "redux"
import { Subscription } from "@rails/actioncable"
import { IBaseAction } from "../../types/baseActionTypes"

export interface ICableSubscriptionRegistration {
  id: string
  channelName: string
  actionPrefix: string
  subscription: Subscription
  isConnected: () => boolean
}

const subscriptions = new Map<string, ICableSubscriptionRegistration>()

export const registerCableSubscription = (registration: ICableSubscriptionRegistration): void => {
  subscriptions.set(registration.id, registration)
}

export const unregisterCableSubscription = (id: string): void => {
  subscriptions.delete(id)
}

export const getCableSubscriptions = (): Map<string, ICableSubscriptionRegistration> => {
  return subscriptions
}

export const clearCableSubscriptions = (): void => {
  subscriptions.clear()
}

export const cableMiddleware: Middleware = store => next => rawAction => {
  const action = rawAction as IBaseAction
  // If action was received from server or marked as from cable, do not re-broadcast
  if (action?.meta?.fromServer || action?.meta?.__cablecar__) {
    return next(action)
  }

  let matched = false
  for (const registration of subscriptions.values()) {
    if (typeof action?.type === "string" && action.type.startsWith(registration.actionPrefix)) {
      matched = true
      if (registration.isConnected()) {
        registration.subscription.send(action)
      } else {
        console.warn(
          `Cable channel "${registration.channelName}" dropped action (not connected):`,
          action
        )
      }
    }
  }

  if (matched) {
    // Optimistic actions update Redux store immediately
    if (action?.meta?.isOptimistic) {
      return next(action)
    }
    // Non-optimistic actions are handled on the server before state is broadcast back
    return store.getState()
  }

  return next(action)
}

export default cableMiddleware
